var backToPrev = document.querySelectorAll('[data-back-to-previous]');

function navigateToPreviousPage() {
  window.history.back();
}

backToPrev.forEach(function (button) {
  button.addEventListener('click', function () {
    navigateToPreviousPage();
  });
});